export class StockItemModel {

  quantity: number;
  name: string;
  uid: number;

  constructor() {

  }
}